import React, { useState, useEffect } from 'react';
import LandingPage      from './components/LandingPage';
import SignupWizard     from './components/SignupWizard';
import SuccessPage      from './components/SuccessPage';
import ManageProfile    from './components/ManageProfile';
import TermsPage        from './components/TermsPage';
import PrivacyPage      from './components/PrivacyPage';
import AdminDashboard   from './components/AdminDashboard';

function getInitialView() {
  const path   = window.location.pathname;
  const params = new URLSearchParams(window.location.search);
  if (path === '/manage') return 'manage';
  if (path === '/terms')  return 'terms';
  if (path === '/privacy') return 'privacy';
  if (path === '/admin')  return 'admin';
  if (params.get('subscribed') === '1') return 'success';
  return 'landing';
}

export default function App() {
  const [view, setView]       = useState(getInitialView);
  const [userData, setUserData] = useState({});

  function navigate(path, newView) {
    window.history.pushState({}, '', path);
    setView(newView);
  }

  useEffect(() => {
    function handlePop() { setView(getInitialView()); }
    window.addEventListener('popstate', handlePop);
    return () => window.removeEventListener('popstate', handlePop);
  }, []);

  if (view === 'success') {
    return (
      <SuccessPage
        data={userData}
        onManage={() => navigate('/manage', 'manage')}
      />
    );
  }

  if (view === 'wizard') {
    return (
      <SignupWizard
        onSuccess={(data) => { setUserData(data); navigate('/', 'success'); }}
        onBack={() => navigate('/', 'landing')}
      />
    );
  }

  if (view === 'manage') {
    return <ManageProfile onBack={() => navigate('/', 'landing')} />;
  }

  if (view === 'terms') {
    return <TermsPage onBack={() => navigate('/', 'landing')} />;
  }

  if (view === 'privacy') {
    return <PrivacyPage onBack={() => navigate('/', 'landing')} />;
  }

  if (view === 'admin') {
    return <AdminDashboard onBack={() => navigate('/', 'landing')} />;
  }

  return (
    <LandingPage
      onStartSignup={() => navigate('/', 'wizard')}
      onManage={() => navigate('/manage', 'manage')}
      onTerms={() => navigate('/terms', 'terms')}
      onPrivacy={() => navigate('/privacy', 'privacy')}
    />
  );
}
